module.exports = __webpack_public_path__ + "static/iPhone--mobile-9688ca1adbf9f2985c8e3568e050869e.png";